import React, { useState, useEffect } from "react";
import { handleCopy } from "@/components/common/commonFunction/handleCopy";
import { PasswordRegExUrl } from "@/common/constants";

const YouTubeThumbnail = () => {
  const [urlLink, setUrlLink] = useState("");
  const [copy, setCopy] = useState<number | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const grabLink = require("youtube-thumbnail-grabber");

  const generateImageUrls = (url: string) => ({
    max: grabLink(url, "max"),
    sd: grabLink(url, "sd"),
    hq: grabLink(url, "hq"),
    mq: grabLink(url, "mq"),
    default: grabLink(url, "default"),
  });

  const imageUrls = urlLink
    ? generateImageUrls(`https://www.youtube.com/watch?v=${urlLink}`)
    : ({} as any);

  const updatedThumbnail = (sequence: number) =>
    imageUrls.default
      ?.split("/")
      .map((item: string) =>
        item === "default.jpg" ? `${sequence}.jpg` : item
      )
      .join("/");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    if (PasswordRegExUrl.test(input)) {
      setUrlLink(input);
      setErr(null);
    } else {
      setUrlLink("");
      setErr("* Please enter a valid YouTube URL");
    }
  };

  const handleCopyToClipboard = (text: string, id: number) => {
    handleCopy(text, () => setCopy(id));
  };

  // const handleDownloadImage = (imageUrl: string, fileName: string) => {
  //   const link = document.createElement("a");
  //   link.href = imageUrl;
  //   link.download = fileName;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleDownloadImage = (imageUrl: string, fileName: string) => {
    const newTab = window.open(imageUrl, "_blank");
    if (newTab) {
      newTab.focus();
    }
  };
  useEffect(() => {
    if (copy !== null) {
      const timer = setTimeout(() => setCopy(null), 1000);
      return () => clearTimeout(timer);
    }
  }, [copy]);

  const renderThumbnailSection = (
    title: string,
    size: string,
    imageUrl: string,
    copyId: number
  ) => (
    <div className="resultion-type-content">
      <h4>{title}</h4>
      <p>Size: {size}</p>
      <div className="thumbnail-preview overflow-auto">
        <img
          alt={`${title} Thumbnail`}
          src={imageUrl}
          style={{ maxWidth: size.split(" x ")[0] + "px" }}
        />
      </div>
      <div className="button youtube-thumbnail-center-alignment mt-3">
        {copy === copyId ? (
          <button>Copied</button>
        ) : (
          <button onClick={() => handleCopyToClipboard(imageUrl, copyId)}>
            Copy URL
          </button>
        )}
        <button
          onClick={() =>
            handleDownloadImage(imageUrl, `${title.toLowerCase()}.jpg`)
          }
        >
          Download
        </button>
      </div>
    </div>
  );

  return (
    <div className="commom-box-new">
      <div className="input-new">
        <input
          type="text"
          placeholder="Enter YouTube URL"
          onChange={handleChange}
          className={err ? "error-input" : ""}
        />
        {err && <span className="error-text">{err}</span>}
      </div>
      {!urlLink ? (
        <div className="youtub-upload-data-link-dummy-box">
          <i className="fa-brands fa-youtube"></i>
          <span>Enter a valid YouTube URL to see the thumbnails</span>
        </div>
      ) : (
        <>
          {renderThumbnailSection(
            "Maximum Resolution",
            "1280 x 720",
            imageUrls.max,
            1
          )}
          {renderThumbnailSection(
            "Standard Definition",
            "640 x 480",
            imageUrls.sd,
            2
          )}
          {renderThumbnailSection("High Quality", "480 x 360", imageUrls.hq, 3)}
          {renderThumbnailSection(
            "Medium Quality",
            "320 x 180",
            imageUrls.mq,
            4
          )}
          {[0, 1, 2, 3].map((seq) =>
            renderThumbnailSection(
              `Mini Thumbnail #${seq + 1}`,
              "120 x 90",
              updatedThumbnail(seq),
              seq + 5
            )
          )}
        </>
      )}
    </div>
  );
};

export default YouTubeThumbnail;
